import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { ARTICLES, UPCOMING_TOPICS, IMG } from '../data/site';
import { Seo } from '../lib/seo';
import { Reveal } from '../components/motion';
import { PageHero, CTABand } from '../components/chrome';

const crumbs = [{ label: 'Home', href: '/' }, { label: 'Insights' }];

export default function InsightsHub() {
  return (
    <div data-testid="page-insights-hub">
      <Seo
        title="Insights: Laboratory Equipment Procurement & Instrumentation Guides | ToxGlobal Analytics"
        description="Procurement guides and technical explainers for government laboratory buyers: how federal labs buy instruments, GC/MS procurement, FTIR vs Raman, and IQ/OQ/PQ validation."
        path="/insights"
        breadcrumbs={crumbs}
      />
      <PageHero
        eyebrow="Insights"
        lines="Field notes for people who buy and run instruments"
        sub="Practical, technically specific writing on procurement, installation, validation, and lifecycle support — written for laboratory directors, procurement staff, and program managers."
        breadcrumbs={crumbs}
        image={IMG.dataMonitors}
        imageAlt="Laboratory insights and guides from ToxGlobal Analytics"
      />

      <section className="section-pad">
        <div className="container-x grid sm:grid-cols-2 gap-8">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={Math.min(i * 0.05, 0.25)}>
              <Link to={`/insights/${a.slug}`} className="group block border border-slate-200 bg-white hover:border-signal transition-colors" data-testid={`insights-card-${a.slug}`}>
                <div className="overflow-hidden aspect-[16/8] bg-midnight">
                  <img src={a.image} alt={a.alt} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-7">
                  <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">{new Date(a.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })} · {a.read}</p>
                  <h2 className="display text-2xl text-ink mt-3 group-hover:text-signal transition-colors">{a.title}</h2>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{a.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-signal">
                    Read the article <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="container-x mt-16">
          <Reveal>
            <div className="border border-slate-300 bg-white p-8" data-testid="upcoming-topics">
              <h2 className="display text-2xl text-ink flex items-center gap-3"><Clock size={18} className="text-signal" /> In the pipeline</h2>
              <p className="mt-2 text-sm text-slate-500">Guides currently in development. Need one sooner? Email info@toxglobal.com and we'll prioritize it.</p>
              <ul className="mt-5 grid sm:grid-cols-2 gap-x-8 border-t border-slate-200">
                {UPCOMING_TOPICS.map((t) => (
                  <li key={t} className="py-3 border-b border-slate-200 text-sm text-slate-600">{t}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
